var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/moment-timezone/index.js
 ** module id = 317
 ** module chunks = 0
 **/